<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
    <v-row>
      <v-col md="12" lg="12" cols="12">
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Promotor se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Promotor se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Promotor se edito con éxito.
       </v-alert>
        <h1 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Promotores {{negocio.negocio}}</h1>
        <br/>
        <v-data-table
      :headers="headers"
      :items="Promotors"
      :single-expand="singleExpand"
      item-key="promotor.id"
      show-expand
      :expanded.sync="expanded"
      class="elevation-1"
      :search="search"
      loading-text="Cargando... Por favor espere"
      style="background-color: #393E46;"
        >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title class="hidden-sm-only hidden-xs-only">Promotores</v-toolbar-title>
          <v-btn @click="damePromotors"><v-icon>fas fa-sync-alt</v-icon></v-btn>

          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <vue-excel-xlsx
              class   = "btn"
              :data="Promotors"
              :columns="columns"
              :filename="'Socios'"

          >
            <v-btn class="mb-2 mr-2"  style="background-color: #6D9886;"><span class="hidden-sm-only hidden-xs-only">Bajar Excel</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-file-excel</v-icon></v-btn>
          </vue-excel-xlsx>
          <v-dialog v-model="dialogMaximos" max-width="500px">
            <v-overlay :value="mxverlay">
              <v-img
                  src="@/assets/loadtunay.gif"

              />
            </v-overlay>
            <template v-slot:activator="{ on }">
              <v-btn color="secondary" dark class="mb-2 mr-2" v-on="on"><span class="hidden-sm-only hidden-xs-only">Cambios Globales</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-globe-americas</v-icon></v-btn>
            </template>
<v-card>
  <v-card-title>
    <span class="headline">Cambiar Globalmente</span>
  </v-card-title>
  <v-card-subtitle>
    Activaciones para todos los promotores a la vez
  </v-card-subtitle>
  <v-card-text>
    <v-row justify="center">
      <v-col cols="2">Lista</v-col>
      <v-col cols="2"><v-btn @click="grabaListasPromotores(1,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaListasPromotores(1,false)" color="error">No</v-btn></v-col>
      <v-col cols="2">Lista QR</v-col>
      <v-col cols="2"><v-btn @click="grabaListasPromotores(2,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaListasPromotores(2,false)" color="error">No</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col cols="2">Jueves</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(4,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(4,false)" color="error">No</v-btn></v-col>

      <v-col cols="2">Viernes</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(5,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(5,false)" color="error">No</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col cols="2">Sabado</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(6,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(6,false)" color="error">No</v-btn></v-col>

      <v-col cols="2">Domingo</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(7,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(7,false)" color="error">No</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col cols="2">Lunes</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(1,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(1,false)" color="error">No</v-btn></v-col>

      <v-col cols="2">Martes</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(2,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(2,false)" color="error">No</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col cols="3">Miercoles</v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(3,true)" color="primary">Si</v-btn></v-col>
      <v-col cols="2"><v-btn @click="grabaDiasPromotores(3,false)" color="error">No</v-btn></v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-autocomplete v-model="idtipolista" :items="tipolistas" label="Tipo de Lista" item-value="id" item-text="tipoListaNombre"></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="canttipolista" type="number"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" @click="grabaCantPromotores">Cambiar</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-autocomplete v-model="idtipolista2" :items="tipolistas" label="Tipo de Lista" item-value="id" item-text="tipoListaNombre"></v-autocomplete>
      </v-col>
      <v-col cols="4"><v-btn @click="grabaActPromotores(true)" color="primary">Activar</v-btn></v-col>
      <v-col cols="4"><v-btn @click="grabaActPromotores(false)" color="error">Desactivar</v-btn></v-col>
    </v-row>
  </v-card-text>
</v-card>
          </v-dialog>
          <v-dialog v-model="dialog" max-width="500px">
            <v-overlay :value="mverlay">
              <v-img
                  src="@/assets/loadtunay.gif"

              />
            </v-overlay>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on"><span class="hidden-sm-only hidden-xs-only">Nuevo Promotor</span><v-icon class=" hidden-md-only hidden-lg-only hidden-xl-only">fas fa-plus</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Nuevo</span>
              </v-card-title>
              <v-card-subtitle>
                Primero ingresa el email para saber si la persona existe en nuestro sistema, si existe te aparecera el nombre y apellido del promotor , si no es el nombre puedes cambiarlo .
              </v-card-subtitle>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field  v-model="pemail"  type="email" @change="verificaremail" label="Email"></v-text-field>
                    </v-col>
                    <v-col  cols="12" sm="12" md="12" lg="12">
                      <v-text-field    v-model="pnombres" label="Nombre"></v-text-field>
                    </v-col>
                    <v-col  cols="12" sm="12" md="12" lg="12">
                      <v-text-field    v-model="pappaterno" label="Apellido Paterno"></v-text-field>
                    </v-col>
                    <v-col  cols="12" sm="6" md="12">
                      <v-switch v-model="esPromotorCabeza" @change="promocabezac" label="Es Promotor Cabeza?">Es Promotor Cabeza?</v-switch>
                    </v-col>
                    <v-col  cols="12" sm="6" md="12">
                        <v-autocomplete
                            v-if="!esPromotorCabeza"
            v-model="ppromotorCabezaId"
            :items="cabezas"
            item-text="promotorNombre"
            item-value="id"
            label="Escoge Cabeza"
            persistent-hint
            single-line
          ></v-autocomplete>
                    </v-col>
                    <v-col  cols="12" sm="6" md="12">
                      <v-switch v-model="esCoordinador" @change="coordinadorc" label="Es Coordinador/Embajador?">Es Coordinador?</v-switch>
                    </v-col>

                    <v-col  cols="12" sm="6" md="12">
                      <v-autocomplete
                          v-if="!esCoordinador"
                          v-model="ppromotorCoordinadorId"
                          :items="coordinadores"
                          item-text="promotorNombre"
                          item-value="id"
                          label="Escoge Coordinador/Embajador"
                          persistent-hint
                          single-line
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="nuevo">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogedit" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Editar Promotor</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col  cols="12" sm="6" md="12">
                      <v-text-field v-model="ppromotorNombre"></v-text-field>
                    </v-col>

                    <v-col  cols="12" sm="6" md="12">
                      <v-autocomplete
                          v-model="ppromotorCabezaId"
                          :items="cabezas"
                          item-text="promotorNombre"
                          label="Escoge Cabeza"
                          persistent-hint
                          item-value="id"
                          single-line
                      ></v-autocomplete>
                      <v-col  cols="12" sm="6" md="12">
                        <v-autocomplete
                            v-model="ppromotorCoordinadorId"
                            :items="coordinadores"
                            item-text="promotorNombre"
                            item-value="id"
                            label="Escoge Coordinador/Embajador"
                            persistent-hint
                            single-line
                        ></v-autocomplete>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="editarpromo">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">Desea eliminar esta Promotor?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
        <v-icon
          small
          color="error"
          @click="deleteItem(item)"
        >
          fas fa-trash-alt
        </v-icon>
      </template>

      <template v-slot:[`item.dactiva`]="{ item }">
        <v-switch v-model="item.promotor.activo" @click="editarel(item)" ></v-switch>
      </template>
          <template v-slot:[`item.dalista`]="{ item }">
            <v-switch v-model="item.promotor.lista" @click="editarel(item)" ></v-switch>
          </template>
          <template v-slot:[`item.daqrlista`]="{ item }">
            <v-switch v-model="item.promotor.qrlista" @click="editarel(item)" ></v-switch>
          </template>
            <template v-slot:[`item.dsub21`]="{ item }">
                <v-switch v-model="item.promotor.superpromotor" @click="editarel(item)" ></v-switch>
            </template>
          <template v-slot:[`item.iscoordinador`]="{ item }">
            <v-switch v-model="item.promotor.esCoordinador" @click="editarel(item)" ></v-switch>
          </template>
          <template v-slot:[`item.iscabeza`]="{ item }">
            <v-switch v-model="item.promotor.esPromotorCabeza" @click="editarel(item)" ></v-switch>
          </template>


      <template v-slot:no-data>
        <v-btn color="primary" @click="damePromotors">Cargar de Nuevo</v-btn>
      </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td class="pa-4" :colspan="headers.length">
                  <v-row>
                    <v-col cols="12">
                      Links
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" lg="2" md="2" sm="12">Link Lista</v-col>
                    <v-col cols="12" lg="6" md="6" sm="12"><a :href="item.link" target="_blank"> {{item.link}} </a></v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">Dias que el promotor puede hacer lista</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" lg="1" md="2" sm="3">Lunes</v-col>
                    <v-col cols="2" lg="1" md="2" sm="3">Martes</v-col>
                    <v-col cols="2" lg="1" md="2" sm="3">Miercoles</v-col>
                    <v-col  cols="2" lg="1" md="2" sm="3">Domingo</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.lunes" @click="editarel(item)" ></v-switch></v-col>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.martes" @click="editarel(item)" ></v-switch></v-col>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.miercoles" @click="editarel(item)" ></v-switch></v-col>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.domingo" @click="editarel(item)" ></v-switch></v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" lg="1" md="2" sm="3">Jueves</v-col>
                    <v-col cols="2" lg="1" md="2" sm="3">Viernes</v-col>
                    <v-col cols="2" lg="1" md="2" sm="3">Sabado</v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.jueves" @click="editarel(item)" ></v-switch></v-col>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.viernes" @click="editarel(item)" ></v-switch></v-col>
                    <v-col cols="2" lg="1" md="2" sm="3"> <v-switch v-model="item.promotor.sabado" @click="editarel(item)" ></v-switch></v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">Tipos de Lista : Activarlos y Cantidad Maxima </v-col>
                  </v-row>
                    <v-row v-for="tipolist in  item.promotorTipoListaList" v-bind:key="tipolist.promotorTipoListaId">
                        <v-col lg="2" md="2" sm="6" cols="3">
                            {{tipolist.tipoLista.tipoListaNombre}}
                        </v-col>
                        <v-col lg="2" md="2" sm="3" cols="3">
                            <v-switch v-model="tipolist.activo" label="Activo" @click="tipolistapromotoract(tipolist)" ></v-switch>
                        </v-col>
                        <v-col lg="3" md="3" sm="4" cols="3">
                            <v-text-field  v-model="tipolist.cant"  type="number" label="Cantidad" onkeyup="tipolistapromotoract(tipolist)" @change="tipolistapromotoract(tipolist)" ></v-text-field>
                        </v-col>
                    </v-row>
                </td>

            </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenu :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import moment from "moment";
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {

  title: 'Promotores | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      drawer: null,
      idnegocio: 0,
      idtipolista:0,
      idtipolista2:0,
      canttipolista:0,
      ppromotorCabezaId:0,
      ppromotorNombre:'',
      ppromotorCoordinadorId: 0,
        emailexist: false,
      progr: true,
      esPromotorCabeza:false,
      esCoordinador:false,
      negocio:{},
      abreviado:'NN',
      token:'',
        singleExpand: true,
        expanded:[],
      overlay: false,
      mverlay: false,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
      dialogedit: false,
      dialogMaximos: false,
      mxverlay:false,
      pemail:'',
      pnombres:'',
      pappaterno:'',
      ppassword:'',
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Promotors: [],
      promotores:[],
        cabezas:[],
      coordinadores:[],
      tipolistas:[],
      search: '',
      idpersona:0,
      editedIndex: -1,
        editedsubIndex: -1,
        editedsubItem:{
          id:0,
          promotor:{},
          tipoLista:{},
            cant:0,
          activo:true
        },
      editedItem: {
      promotor:{ id: 0,
        activo:false,
          borrado: false,
          importante: false,
        hashPromotor:'',
          sub21: false,
          lunes: false,
          martes: false,
          miercoles: false,
          jueves: false,
          viernes: false,
          sabado: false,
          domingo: false,
          superpromotor:  false,
        promotorNombre:'',
        promotorEmail:'',
        idPersona:0,
        idNegocio:0,
        negocioNombre:'',
        negocioTag:'',
        coordinador:{
          coordinadorId:0,
          coordinador:''
        },
        promotorCabezaDTO:{
          promCabezaId:0,
          promCabeza:''
        },
        esPromotorCabeza:false,
        esCoordinador:false,
        lista:true,
        qrlista:true
        },
        promotorTipoListaList:[],
        link:'',
        linkqr:''
      } ,
    defaultItem: {
      id: 0,
      activo:false,
      borrado: false,
      importante: false,
      hashPromotor:'',
      sub21: false,
      lunes: false,
      martes: false,
      miercoles: false,
      jueves: false,
      viernes: false,
      sabado: false,
      domingo: false,
      superpromotor:  false,
      personaId:0,
      negocioId:0,
      link:true,
      linkqr:true,
      promotorCabezaId:0,
      coordinadorId:0,
        esPromotorCabeza:false,
        esCoordinador:false
    },
      columns:[
        {
          label: "Nombre",
          field: "promotor.promotorNombre",
        },
        {
          label: "Link",
          field: "link",
        },
        {
          label: "Activo",
          field: "promotor.activo",
        }
      ],
headers: [
    { text: '', value: 'data-table-expand', sortable: false },
    { text: 'Acciones', value: 'action', sortable: false },
    { text: 'Activo', value: 'dactiva', sortable: false },
  { text: 'Es Cabeza?', value: 'iscabeza', sortable: false },
  { text: 'Es Coordinador/Embajador?', value: 'iscoordinador', sortable: false },
  { text: 'Mostrar Lista', value: 'dalista', sortable: false },
  { text: 'Mostrar QR', value: 'daqrlista', sortable: false },
    { text: 'A toda hora', value: 'dsub21', sortable: false },
    { text: 'Nombre', align: 'left',  value: 'promotor.promotorNombre'},
  { text: 'Cabeza', align: 'left',  value: 'promotor.promotorCabezaDTO.promCabeza'},
  { text: 'Coordinador/Embajador', align: 'left',  value: 'promotor.coordinador.coordinador'}

      ]
  }),
  mounted (){
        this.idnegocio =  this.$route.params.idnegocio
        this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
            this.overlay = true
        if (this.usuario.id === undefined){

          firebase
              .auth()
              .onAuthStateChanged(user => {
                if(user){
                  this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                  this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

                  this.overlay = false
                  this.damePromotors();
                  this.damecabezas();
                  this.dameTipoListas();
                }else{
                  this.overlay = false
                  this.$router.push({ path: '/' });
                }
              })
        }else{
          this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
          this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

          this.overlay = false
          this.damePromotors();
          this.damecabezas();
          this.dameTipoListas();
        }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
     '$store.state.cliente': function (){
       this.damePromotors();
       this.damecabezas();
     },
    "$route.params.idnegocio"(value) {
          console.log(value);
           this.idnegocio =  this.$route.params.idnegocio
           this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
          if (this.usuario.id === undefined){
            this.$router.push({ path: '/' });
          }else{
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            this.damePromotors();
            this.damecabezas();
          }
    },
  },
  methods : {
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    dameTipoListas(){
      this.progr = true;
      axios
          .get('tipolistas/negocio/' + this.idnegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          } )
          .then(response => {
            this.tipolistas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    editadefault(){
      this.defaultItem.id = this.editedItem.promotor.id
      this.defaultItem.activo= this.editedItem.promotor.activo
      this.defaultItem.borrado= this.editedItem.promotor.borrado
      this.defaultItem.importante= this.editedItem.promotor.importante
      this.defaultItem.hashPromotor= this.editedItem.promotor.hashPromotor
      this.defaultItem.sub21= this.editedItem.promotor.sub21
      this.defaultItem.lunes= this.editedItem.promotor.lunes
      this.defaultItem.martes= this.editedItem.promotor.martes
      this.defaultItem.miercoles= this.editedItem.promotor.miercoles
      this.defaultItem.jueves= this.editedItem.promotor.jueves
      this.defaultItem.viernes= this.editedItem.promotor.viernes
      this.defaultItem.sabado= this.editedItem.promotor.sabado
      this.defaultItem.domingo= this.editedItem.promotor.domingo
      this.defaultItem.superpromotor= this.editedItem.promotor.superpromotor
      this.defaultItem.negocioId = this.editedItem.promotor.idNegocio
      this.defaultItem.personaId = this.editedItem.promotor.idPersona
      this.defaultItem.promotorCabezaId = this.editedItem.promotor.promotorCabezaDTO.promCabezaId
      this.defaultItem.coordinadorId = this.editedItem.promotor.coordinador.coordinadorId
      this.defaultItem.link = this.editedItem.promotor.lista
      this.defaultItem.linkqr = this.editedItem.promotor.qrlista
      this.defaultItem.promotorNombre = this.editedItem.promotor.promotorNombre
        this.defaultItem.esCoordinador = this.editedItem.promotor.esCoordinador
        this.defaultItem.esPromotorCabeza = this.editedItem.promotor.esPromotorCabeza

    },
    verificaremail(){
      this.overlay=true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("email",this.pemail);
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.overlay=false
           let persona = response.data
            if (persona.id == null){
                this.emailexist = true
              this.pnombres = ''
              this.pappaterno = ''
              this.idpersona = 0
            }else{
              this.emailexist = false
              this.pnombres = persona.nombre
              this.pappaterno = persona.apellidoPaterno
              this.idpersona = persona.id
            }

          })
          .catch((error)  => {
            this.overlay = false
            console.log(error);
          });
    },
    promocabezac(){
      if(this.esPromotorCabeza){
        this.ppromotorCabezaId = 0;
      }
    },
    coordinadorc(){
      if(this.esCoordinador){
        this.ppromotorCoordinadorId = 0;
      }
    },
    damePromotors(){
      this.overlay = true;
      this.progr = true;
      var bodyFormData2 = new FormData();
      bodyFormData2.append("tag",this.idnegocio);
      bodyFormData2.append("base",process.env.VUE_APP_ROOT_API);
        axios
        .post('promotores/negocio',bodyFormData2,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.promotores = response.data
            this.Promotors = this.promotores.filter(x=>x.promotor.borrado === false)

            this.overlay = false;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
        this.overlay = false
        });
    },
      damecabezas(){
          this.progr = true;
          let urlcabezas = 'promotores/cabezas/' + this.idnegocio ;
          axios
              .get(urlcabezas,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
              .then(response => {
                  this.cabezas = response.data;
                  this.progr = false;
                  this.alertborrador = false;
                  this.alertnuevo = false;
                  this.alerteditar = false;
                  this.damecoordinadores();
              })
              .catch((error)  => {
                  console.log(error);
              });
      },
    damecoordinadores(){
      this.progr = true;
      let urlcabezas = 'promotores/coordinadores/' + this.idnegocio ;
      axios
          .get(urlcabezas,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.coordinadores = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    editItem (item) {
      this.editedIndex = this.Promotors.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.ppromotorNombre = this.editedItem.promotor.promotorNombre
      this.ppromotorCabezaId = this.editedItem.promotor.promotorCabezaDTO.promCabezaId
      this.ppromotorCoordinadorId = this.editedItem.promotor.coordinador.coordinadorId
      this.dialogedit = true
    },
       tipolistapromotoract (cale) {
          this.editedsubItem = Object.assign({},cale)
        var bodyFormData2 = new FormData();
        bodyFormData2.append("id",this.editedsubItem.id);
        bodyFormData2.append("cantidad",this.editedsubItem.cant);
        bodyFormData2.append("activo",this.editedsubItem.activo);
          axios
              .post('promotortipolistas/actualiza',bodyFormData2,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
              .catch(error => {
                  this.error = "Hubo un error";
                  console.log(error);
              });
      },
    grabaActPromotores(activa) {
      this.mxverlay = true
      var bodyFormData2 = new FormData();
      bodyFormData2.append("tipoListaId",this.idtipolista2);
      bodyFormData2.append("activo",activa);
      axios
          .post('promotores/todos/listas/act',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response)
            this.mxverlay = false
            this.dialogMaximos = false
            this.damePromotors();
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.mxverlay = false

            this.dialogMaximos = false
            console.log(error);
          });
    },
    grabaCantPromotores() {
      this.mxverlay = true
      var bodyFormData2 = new FormData();
      bodyFormData2.append("tipoListaId",this.idtipolista);
      bodyFormData2.append("cant",this.canttipolista);
      axios
          .post('promotores/todos/listas/cant',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response)
            this.mxverlay = false
            this.dialogMaximos = false
            this.damePromotors();
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.mxverlay = false

            this.dialogMaximos = false
            console.log(error);
          });
    },
    grabaDiasPromotores (dia,activo) {
      this.mxverlay = true
      var bodyFormData2 = new FormData();
      bodyFormData2.append("negocioId",this.negocio.id);
      bodyFormData2.append("diaId",dia);
      bodyFormData2.append("activo",activo);
      axios
          .post('promotores/todos/dias',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response)
            this.mxverlay = false
            this.dialogMaximos = false

            this.damePromotors();
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.mxverlay = false

            this.dialogMaximos = false
            console.log(error);
          });
    },
    grabaListasPromotores (tipo,activo) {
      this.mxverlay = true
      var bodyFormData2 = new FormData();
      bodyFormData2.append("negocioId",this.negocio.id);
      bodyFormData2.append("tipo",tipo);
      bodyFormData2.append("activo",activo);
      axios
          .post('promotores/todos/listas',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.log(response)
            this.mxverlay = false
            this.dialogMaximos = false
            this.damePromotors();
          })
          .catch(error => {
            this.error = "Hubo un error";
            this.mxverlay = false

            this.dialogMaximos = false
            console.log(error);
          });
    },
      editarel (item) {
      this.overlay = true
          this.editedItem = Object.assign({}, item)
          this.editadefault()
        var bodyFormData = new FormData();
        bodyFormData.append("data",JSON.stringify(this.defaultItem));
        bodyFormData.append("base",process.env.VUE_APP_ROOT_API);

        axios
              .post('promotores/editar',bodyFormData,{
                headers: {
                  'Authorization': `Bearer ${this.token}`,
                }
              })
            .then(response => {
              //this.promotores = response.data
              console.log(response.data)
              this.Promotors = this.promotores.filter(x=>x.promotor.borrado === false)
              this.overlay = false;
              this.progr = false;
              this.alertborrador = false;
              this.alertnuevo = false;
              this.alerteditar = false;
            })
              .catch(error => {
                  this.error = "Hubo un error";
                  this.overlay = false
                  console.log(error);
              });
      },
    deleteItem (item) {
      this.editedIndex = this.Promotors.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogdelete = true;
    },
    borralo(){
      this.editedItem.promotor.borrado = true
      this.editadefault()

      var bodyFormData = new FormData();
      bodyFormData.append("data",JSON.stringify(this.defaultItem));
      bodyFormData.append("base",process.env.VUE_APP_ROOT_API);
      axios
          .post('promotores/editar',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
      .then(response => {
                console.log(response);
                 this.dialogdelete = false;
        this.alertborrador = true;
        this.Promotors = this.promotores.filter(x=>x.promotor.borrado === false)
        this.overlay = false;
        this.progr = false;
        this.close();
                })
      .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });
    },
    close () {
      this.dialog = false;
      this.dialogdelete = false;
      this.dialogedit = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    nuevo(){
      this.mverlay = true;
      let obj = {
        id: this.idpersona,
        nombre: this.pnombres,
        appaterno: this.pappaterno,
        negocioId: this.negocio.id,
        espromotorcabeza: this.esPromotorCabeza,
        escoordinador: this.esCoordinador,
        promotorCabezaId: this.ppromotorCabezaId,
        coordinadorId : this.ppromotorCoordinadorId,
        base : process.env.VUE_APP_ROOT_API,
        email: this.pemail
      }

              axios
                  .post('promotores/grabar',obj,{
                    headers: {
                      'Content-Type':'application/json',
                      'Authorization': `Bearer ${this.token}`
                    }
                  }).then(response => {
                this.promotores = response.data
                this.Promotors = this.promotores.filter(x=>x.promotor.borrado === false)
                this.pemail = ''
                this.ppassword = ''
                this.pnombres = ''
                this.pappaterno  = ''
                this.ppromotorCabezaId = 0
                this.ppromotorCoordinadorId = 0
                this.alerteditar = true;
                this.mverlay = false;
                this.emailexist = false;
                this.damecabezas();
                this.close();
              })
                  .catch(error => {
                    this.error = "Hubo un error";
                    this.mverlay = false;
                    console.log(error);
                    this.close();
                  });



    },
    editarpromo () {
        this.overlay = true;
      var bodyFormData = new FormData();
        Object.assign(this.Promotors[this.editedIndex], this.editedItem);
        console.log(this.editedItem)
      this.editedItem.promotor.promotorCabezaDTO.promCabezaId = this.ppromotorCabezaId
      this.editedItem.promotor.coordinador.coordinadorId = this.ppromotorCoordinadorId
      this.editedItem.promotor.promotorNombre = this.ppromotorNombre
        this.editadefault()
        bodyFormData.append("data",JSON.stringify(this.defaultItem));
        bodyFormData.append("base",process.env.VUE_APP_ROOT_API);

        axios
      .post('promotores/editar',bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
        //this.promotores = response.data
          console.log(response.data)
                this.alerteditar = true;
          this.overlay = false;
          this.progr = false;
          this.close();

                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });


    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Promotor' : 'Editar Promotor'
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
<style scoped>
.grecaptcha-badge{
  display: none !important;
}
</style>
